import { getCardsServiceLocationBase } from '../../common/api/data';
import { useEffect, useState } from "react";
import Card from './card';
//import { useState, useEffect, useMemo } from "react";

interface ICard {
	suit: string;
	rank: string;
}

const post = {
	method: 'POST',
	//headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
};

const get = {
	method: 'GET',
	//headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
};

const Cards = () => {
	
	const [deckId, setDeckId] = useState<string | null>(null);
	const [cards, setCards] = useState<ICard[]>([]);

	useEffect( () => {
		console.log('mounting cards component');
		pageLoad();
	}), [];

	const pageLoad = async () => {
	};

	const getDeck = (): void => {
		fetch(`${getCardsServiceLocationBase()}/createdeck`, post).then(r => {
			r.json().then(j => {
				fetch(`${getCardsServiceLocationBase()}/shuffledeck/${j.message}`, post).then(r2 => {
					r2.json().then(j2 => {
						fetch(`${getCardsServiceLocationBase()}/retrievedeck/${j2.message}`, get).then(r3 => {
							r3.json().then(j3 => {
								//console.log('json');
								console.log(j3);
								console.log(j3.deckId);
								setDeckId(j3.deckId);
								setCards(j3.cards);
							})
							.catch(f => {
								console.log('error deserializing retrieve deck response json');
								console.log(f);
							});
						})
						.catch(e => {
							console.log('error fetching retrieve deck response');
							console.log(e);
						});
					})
					.catch(f => {
						console.log('error deserializing shuffle deck response json');
						console.log(f);
					});
				})
				.catch(e => {
					console.log('error fetching shuffle deck response');
					console.log(e);
				});
			})
			.catch(f => {
				console.log('error deserializing create deck response json');
				console.log(f);
			});
		})
		.catch(e => {
			console.log('error fetching create deck response');
			console.log(e);
		});
	};

	const renderDeck = () => {
		return (
			<div>
				{
				!deckId ? 'No Deck' : 
				<div className='cardtable'>
					Deck with {cards.length} cards!<br />
					{
						cards.map((c : ICard) => (
							<span key={c.rank + '_' + c.suit}>
								<Card suit={c.suit} rank={c.rank} />
							</span>
						))
					}
				</div>
				}
			</div>
		);
	};

	return (
		<div>
			Cards!<br />
			<button onClick={() => getDeck()}>Get Deck</button>
			<br />
			{renderDeck()}
		</div>
	);

};

export default Cards;